var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.50033C15.8333 10.722 13.2217 13.3337 10 13.3337M15.8333 7.50033C15.8333 4.27866 13.2217 1.66699 10 1.66699M15.8333 7.50033H4.16667M10 13.3337C6.77834 13.3337 4.16667 10.722 4.16667 7.50033M10 13.3337C11.4591 11.7363 12.289 9.66331 12.3341 7.50033C12.289 5.33735 11.4591 3.26436 10 1.66699M10 13.3337C8.54092 11.7363 7.71249 9.66331 7.66743 7.50033C7.71249 5.33735 8.54092 3.26436 10 1.66699M10 13.3337V15.0003M4.16667 7.50033C4.16667 4.27866 6.77834 1.66699 10 1.66699M11.6667 16.667C11.6667 17.5875 10.9205 18.3337 10 18.3337C9.07953 18.3337 8.33333 17.5875 8.33333 16.667M11.6667 16.667C11.6667 15.7465 10.9205 15.0003 10 15.0003M11.6667 16.667H17.5M8.33333 16.667C8.33333 15.7465 9.07953 15.0003 10 15.0003M8.33333 16.667H2.5",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.5f6f9b94554fbb422676cbac9766495c.svg";
export { ForwardRef as ReactComponent };